/*
 *  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
 *  ~ No part of this publication may be reproduced, distributed,
 *  ~ or transmitted in any form or by any means, including photocopying, recording,
 *  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
 *  ~ except in the case of brief quotations embodied in critical
 *  ~ reviews and certain other noncommercial uses permitted by copyright law.
 *  ~ Author : BS
 *  ~ Date : 2/8/23, 5:31 PM
 */

import { Factory, QuickFactory } from '@infodata-group/inf-commons';
import { Bbx } from '../model/bbx';

export class BbxFactory extends QuickFactory implements Factory<Bbx> {
  constructor() {
    super();
  }

  build(o: any): Bbx {
    const bbx = new Bbx();
    this.generateProperty(bbx, o);
    bbx.bbxPicture = o.bbxPicture;
    bbx.lowEngin = o.lowEngin;
    bbx.highEngin = o.highEngin;
    return bbx;
  }

  getApi(): string {
    return `administration/bbx/`;
  }
}
